import React, { Component } from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import isEmpty from "lodash/isEmpty";
import orderBy from "lodash/orderBy";
import find from "lodash/find";
import isObject from "lodash/isObject";
import { IoArrowRedo } from "react-icons/io5";
import { Link } from "react-router-dom";

import { customToast as toast, stripHtml } from "../../utils";

import Alert from "../common/Alert";
import CustomTextarea from "../common/Textarea";
import CustomInput from "../common/Input";
import Checkbox from "../common/Checkbox";

import DropdownSearchSelect from "./timesheet/DropdownSearchSelect";

import TasksServiceContainer from "./TasksServiceContainer";
import ServiceNote from "./ServiceNote";
import TimesheetProgressBar from "./timesheet/TimesheetProgressBar";

class CallDetailsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {
    if (this.props.call?.tasks?.length && !this.state?.calls?.length) {
      this.setState({ tasks: this.props.call.tasks });
    }
    if (!isEmpty(this.props.call)) {
      const office = find(this.props.codes, {
        entity: "Call",
        value: "OFFICE"
      });
      this.setState({
        workplace: this.props.call.workplace || office.id,
        billing_description: stripHtml(this.props.call.billing_description),
        internal_notes: this.props.call.internal_notes,
        fixed_time: this.props.call.fixed_time,
        off_hours: this.props.call.off_hours
      });
    }

    if (this.props.project) {
      if (this.props.call.call_type) {
        this.setState({
          call_type: this.props.call.call_type._id || this.props.call.call_type
        });
      } else if (this.props.project && !this.props.call.call_type) {
        const call_type = find(this.props.codes, {
          entity: "Call",
          value: this.props.project.call_type.value
        });

        this.setState({ call_type: call_type._id });
      }
    }

    if (this.props.service) {
      this.setState({ service: this.props.service });
    }
  };

  onChange = (field, selected) => {
    this.setState({ [field]: selected.value || selected });
  };

  onCheckboxChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onServiceChange = (value) => {
    this.setState({
      service: value,
      tasks: this.state.tasks.map((task) => ({
        ...task,
        service: value,
        service_task: ""
      }))
    });
  };

  getCodeOptions = (entity, field) => {
    const codeOptions = this.props.codes
      .filter((codes) => codes.entity === entity && codes.field === field)
      .map((code) => ({
        value: code._id,
        label: code.label,
        order: code.order
      }));

    return orderBy(codeOptions, "label");
  };

  genContactOptions = () => {
    let contactOptions = [];

    if (this.props.customer && this.props.customer.contacts) {
      contactOptions = this.props.customer.contacts.map((contact) => ({
        value: contact._id,
        label: `${contact.first_name} ${contact.last_name}`
      }));
    }
    return contactOptions;
  };

  submit = (e) => {
    e.preventDefault();
    const nullServiceTask = this.state.tasks.find((task) => !task.service_task);
    if (this.state.tasks.length && !nullServiceTask) {
      this.props.onSave({
        ...this.state,
        support_ticket_id: this.props.call?.support_ticket_id || null
      });
    } else if (nullServiceTask) {
      toast.error("All fields on tasks are required");
    } else {
      toast.error("Please add some tasks");
    }
  };

  render() {
    const { service } = this.state;
    const {
      call,
      customer,
      project,
      contract,
      dates,
      auth,
      getServiceOptions
    } = this.props;
    if (call.actual_hrs === "") {
      call.actual_hrs = 0;
    }

    const canSubmit = !!(
      this.state.tasks?.length &&
      !this.state.tasks.some(
        (task) => !task.service_task || task.actual_duration === ""
      ) &&
      this.state.internal_notes &&
      this.state.internal_notes.length <= 500 &&
      (!this.state.billing_description ||
        this.state.billing_description.length <= 100) &&
      !isObject(this.state.workplace)
    );

    const serviceSelectData = getServiceOptions(customer?._id, project);

    return (
      <React.Fragment>
        <Alert show={customer?.bc_blocked === "All"}>
          <p>
            This customer’s account has been blocked in Business Central. Please
            check with your manager.
          </p>
        </Alert>
        <TimesheetProgressBar
          clearProjectOnUnmount
          projectId={call.project?._id ? call.project._id : project._id}
          call={call}
          tasks={this.state.tasks}
          dates={dates}
          auth={auth}
        />
        <form
          className="vertical form time-entry call-details"
          onSubmit={this.submit}
        >
          <Row>
            {service && (
              <>
                <Col xs={12}>
                  <TasksServiceContainer
                    serviceId={service}
                    tasks={this.state.tasks}
                    call={call}
                    adding={!call._id}
                    onChange={this.onChange}
                  />
                </Col>
              </>
            )}
            <Col md={6}>
              <CustomTextarea
                required
                formNoValidate
                name="internal_notes"
                label="Internal Notes"
                value={call.internal_notes}
                validations={{ maxLength: 500 }}
                validationErrors={{
                  maxLength: "You can not type in more than 500 characters"
                }}
                onChange={this.onChange}
              />
            </Col>
            <Col md={6}>
              <CustomTextarea
                formNoValidate
                name="billing_description"
                label="Customer Billing Notes"
                value={call.billing_description}
                validations={{ maxLength: 100 }}
                validationErrors={{
                  maxLength: "You can not type in more than 100 characters"
                }}
                onChange={this.onChange}
              />
            </Col>
            {project && project.requestor_required && (
              <Col md={12} xs={12}>
                <CustomInput
                  required={project && project.requestor_required}
                  name="project_requestor"
                  label="Project Requestor"
                  value={this.state.project_requestor || call.project_requestor}
                  onChange={this.onChange}
                />
              </Col>
            )}
            <React.Fragment>
              <Col md={6} />
              <Col md={6}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {call?.support_ticket_id ? (
                    <div>
                      <Link
                        to={`/app/support-tickets/${call.support_ticket_id}`}
                        style={{
                          fontWeight: "700",
                          paddingTop: "10px !important"
                        }}
                        target="_blank"
                      >
                        View Ticket
                        <IoArrowRedo style={{ paddingLeft: "3px" }} />
                      </Link>
                    </div>
                  ) : (
                    <div />
                  )}
                  {call?._id && (
                    <div>
                      <Link
                        exact
                        to={`/app/calls/${call._id}`}
                        style={{
                          fontWeight: "700",
                          paddingTop: "10px !important"
                        }}
                        target="_blank"
                      >
                        View Call Entry
                        <IoArrowRedo style={{ paddingLeft: "3px" }} />
                      </Link>
                    </div>
                  )}
                </div>
              </Col>
            </React.Fragment>
            {call?._id && (
              <Col md={3}>
                <DropdownSearchSelect
                  label="Service"
                  name="service"
                  value={service}
                  onChange={(name, selected) =>
                    this.onServiceChange(selected.value)
                  }
                  data={serviceSelectData}
                />
              </Col>
            )}
            <Col md={3}>
              <DropdownSearchSelect
                disabled
                name="call_type"
                label="Call Type"
                data={this.getCodeOptions("Call", "type")}
                onChange={this.onChange}
                value={
                  this.state.call_type || (call.call_type && call.call_type._id)
                }
              />
            </Col>
            <Col md={3}>
              <DropdownSearchSelect
                required
                name="workplace"
                label="Workplace"
                data={this.getCodeOptions("Call", "workplace")}
                onChange={this.onChange}
                value={this.state.workplace || call.workplace}
              />
            </Col>
            <Col md={3}>
              <div className="checkbox-group">
                <Checkbox
                  checked={this.state.off_hours}
                  name="off_hours"
                  label="Off Hours"
                  value={this.state.off_hours}
                  onClickCheck={(e) =>
                    this.onCheckboxChange("off_hours", e.target?.checked)
                  }
                />
                <Checkbox
                  checked={this.state.fixed_time}
                  name="fixed_time"
                  label="Fixed Time"
                  value={this.state.fixed_time}
                  onClickCheck={(e) =>
                    this.onCheckboxChange("fixed_time", e.target?.checked)
                  }
                />
              </div>
            </Col>
          </Row>

          {contract && <ServiceNote note={contract.service_note} />}
          <Row>
            <Col md={12} className="footer">
              {call._id && (
                <button
                  disabled={
                    call?.call_type?.value === "PERSONAL" && !auth.isAdmin
                  }
                  className="btn  btn-warning"
                  type="button"
                  onClick={() => this.props.onDelete(call._id)}
                >
                  Delete
                </button>
              )}
              <button
                className="btn  btn-cancel"
                type="button"
                onClick={this.props.onCancel}
              >
                Cancel
              </button>
              <input
                className="btn  btn-success"
                type="submit"
                disabled={!canSubmit || this.props.saving}
                value={this.props.saving ? "Saving... " : "Save"}
              />
            </Col>
          </Row>
        </form>
      </React.Fragment>
    );
  }
}

CallDetailsForm.propTypes = {
  saving: PropTypes.bool,
  onSave: PropTypes.func,
  call: PropTypes.object,
  contract: PropTypes.object,
  codes: PropTypes.array,
  project: PropTypes.object,
  onCancel: PropTypes.func,
  customer: PropTypes.object,
  service: PropTypes.string,
  onDelete: PropTypes.func,
  dates: PropTypes.array,
  auth: PropTypes.object,
  getServiceOptions: PropTypes.func
};

export default CallDetailsForm;
